module.exports = __webpack_public_path__ + "img/interesse_2_selecionado.36b6aa37.svg";